import { ActionTree } from 'vuex'
import { PowerIncreasePackagesState } from './types';
import { RootState } from '@/store/types';

export const actions: ActionTree<PowerIncreasePackagesState, RootState> = {
}